import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { acceptQuote, declineQuote, getQuote } from './api';
import { QuoteScene } from './scene';

export default function Quote() {
  const { viewToken } = useParams<{ viewToken: string }>();
  const [quote, setQuote] = useState<Kudable.QuotePublic | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [acceptedBookingToken, setAcceptedBookingToken] = useState<
    string | null
  >(null);
  const [declined, setDeclined] = useState(false);

  useEffect(() => {
    if (!viewToken) return;
    getQuote(viewToken)
      .then((res) => setQuote(res.data.quote))
      .catch(() => setLoadError('This quote link is invalid or has expired.'));
  }, [viewToken]);

  const handleAccept = () => {
    if (!viewToken) return;
    setSubmitting(true);
    acceptQuote(viewToken)
      .then((res) => setAcceptedBookingToken(res.data.booking.view_token))
      .catch(() => null)
      .finally(() => setSubmitting(false));
  };

  const handleDecline = (reason?: string) => {
    if (!viewToken) return;
    setSubmitting(true);
    declineQuote(viewToken, reason)
      .then(() => setDeclined(true))
      .catch(() => null)
      .finally(() => setSubmitting(false));
  };

  return (
    <QuoteScene
      quote={quote}
      loadError={loadError}
      submitting={submitting}
      acceptedBookingToken={acceptedBookingToken}
      declined={declined}
      onAccept={handleAccept}
      onDecline={handleDecline}
    />
  );
}
